import React from 'react';
import { connect } from 'react-redux';
import { IonButton, IonItem, IonInput, IonLabel, IonAlert } from '@ionic/react';
import { withRouter } from 'react-router';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { Spacer, NormalText } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import './index.css';
import TermsModal from '../../components/termsModal';
import { getProfile, getStudentBeansUrl, setCommonProp } from '../../store/actions';
import { getConfig } from '../../appConfig';
import { showToast } from '../../store/actions';
import moment from '../../lib/moment';

class Students extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTerms: false,
      showSuccessAlert: false,
      successMessage: '',
      showErrorAlert: false,
      errorMessage: '',
    };
    this.test = false;
    
  }

  handleVerificationParams = (location) => {
    const params = new URLSearchParams(location.search || '');
    const message = params.get('message');
    let verified = params.get('verified');
    const errorCode = params.get('error_code') || "";
    if (!verified && location.state && location.state.verified) {
      verified = location.state.verified;
    }

    if (verified === 'true' || verified === 'false') {
      const { __ } = this.props;
      const studentBeansConfig = getConfig()?.studentBeans || {};
      if (message) {
        this.setState({ showSuccessAlert: verified === 'true', successMessage: __(message), showErrorAlert: verified === 'false', errorMessage: __(message), errorCode: errorCode });
      } else if (verified === 'true') {
        this.setState({ showSuccessAlert: true, successMessage: __(studentBeansConfig?.verificationSuccessfulMessage || 'Your student status has been successfully verified!') });
      } else {
        this.setState({ showErrorAlert: true, errorMessage: __(studentBeansConfig?.verificationFailedlMessage || 'Student verification failed!'), errorCode: errorCode });
      }
      this.props.dispatch(getProfile());
    }
  };

  componentDidMount() {
    this.handleVerificationParams(this.props.location);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location !== prevProps.location) {
      this.handleVerificationParams(location);
    }
  }

  getStudentValidationState = () => {
    const profile = this.props.profile || {};
    const isValidated = profile.student_confirmed === true;
    const expiryMoment = profile.student_expiry_date && moment(profile.student_expiry_date).isValid()
        ? moment(profile.student_expiry_date)
        : null;

    if (isValidated && expiryMoment) {
      const isExpired = moment().isAfter(expiryMoment, 'day');
      return !isExpired;
    }
    return isValidated;
  };

  getOrdinalSuffix = (day) => {
    if (day >= 11 && day <= 13) {
      return 'th';
    }

    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  formatExpiryDate = (expiryMoment) => {
    const day = expiryMoment.date();
    const suffix = this.getOrdinalSuffix(day);
    const monthAndYear = expiryMoment.format('MMMM YYYY').toUpperCase();
    return `${day}${suffix} ${monthAndYear}`;
  };

  render() {
    const { __, terms, history, profile } = this.props;
    const studentBeansConfig = getConfig()?.studentBeans || {};
    const isValidated = this.getStudentValidationState();
    const expiryMoment = profile.student_expiry_date && moment(profile.student_expiry_date).isValid()
        ? moment(profile.student_expiry_date)
        : null;
    const isRenewalMonth = expiryMoment ? moment().isSame(expiryMoment, 'month') : false;
    const shouldShowUnlockBenefits = studentBeansConfig?.isVisible && (!isValidated || isRenewalMonth);
    const formattedExpiryDate = isValidated && expiryMoment ? this.formatExpiryDate(expiryMoment) : null;
    return (
      <Loading transparent>
        <Layout
          color="transparent"
          showHeader
          showFooter
          showBack
          hideSecondToolbar={true}
          headerTitle={__('Students')}
        >
          <NormalText className="contact-subtitle">
            {__(
              'SOURDOUGH PIZZA MAKES YOU SMART! STUDENTS GET 2 BONUS STAMPS ON EVERY STAMP CARD.',
            )}
          </NormalText>
          <Spacer />
          <IonLabel style={{ flex: 1 }} color="primary" className="comment-wrapper-light student-status-info">
            {isValidated && formattedExpiryDate ? (
              <>
                <NormalText className="uppercase bold blocked-input">
                  {__(`STUDENT STATUS VALID.`)}
                </NormalText>
                <Spacer size={1} />
                <NormalText className="uppercase bold blocked-input">
                  {__(`NEXT RENEWAL BY`)}
                </NormalText>
                <NormalText className="uppercase bold blocked-input">
                  {__(`${formattedExpiryDate}`)}
                </NormalText>
                <Spacer size={1} />
              </>
            ) :
              <>
                <NormalText className="uppercase bold blocked-input">
                  {__(
                    'NO NEED TO TELL US YOUR GRADES, BUT WE DO NEED TO CONFIRM YOUR STUDENT STATUS.',
                  )}
                </NormalText>
                <Spacer size={1} />
                <NormalText className="uppercase bold blocked-input">
                  {__(
                    'CLICK THE "UNLOCK BENEFITS" BUTTON BELOW TO VALIDATE YOUR PROFILE USING YOUR STUDENT BEANS ACCOUNT.',
                  )}
                </NormalText>
                <Spacer size={1} />
                <NormalText className="uppercase bold blocked-input">
                  {__(
                    `ONCE YOUR STUDENT STATUS IS VERIFIED, YOU’LL AUTOMATICALLY RECEIVE 2 BONUS STAMPS ON EVERY STAMP CARD.`,
                  )}
                </NormalText>
              </>
            }
          </IonLabel>
          <Spacer size={1} />


          { shouldShowUnlockBenefits ? (
            <IonButton
              className="student-button"
              expand="block"
              color="secondary"
              strong={true}
              onClick={() => this.props.dispatch(getStudentBeansUrl())}
            >
              {__(studentBeansConfig?.buttonText ? studentBeansConfig?.buttonText : 'Unlock benefits')}
            </IonButton>
            ) : null
          }
        </Layout>
        <TermsModal
          isOpen={this.state.showTerms}
          onDidDismiss={() => this.setState({ showTerms: false })}
        />
        <IonAlert
          cssClass="no-table-alert one-red-button-alert"
          isOpen={this.state.showSuccessAlert}
          onDidDismiss={() => this.setState({ showSuccessAlert: false })}
          message={__(this.state.successMessage || 'Your student status has been successfully verified!')}
          header={__('Success')}
          buttons={[
            {
              text: __('OK'),
              cssClass: 'secondary',
              handler: () => this.setState({ showSuccessAlert: false }),
            },
          ]}
        />
        <IonAlert
          isOpen={this.state.showErrorAlert}
          onDidDismiss={() => this.setState({ showErrorAlert: false })}
          header={__('Oops')}
          message={__(`${this.state.errorMessage || 'Something went wrong while verifying your student status. Please try again later.'} ${this.state.errorCode ? ` <br/><br/> Error code: ${this.state.errorCode}` : ''}`)}
          cssClass="no-table-alert one-red-button-alert"
          buttons={[
            {
              text: __('OK'),
              cssClass: 'two-button-secondary',
              handler: () => this.setState({ showErrorAlert: false }),
            },
          ]}
        />
      </Loading>
    );
  }
}
const stateToProps = (store) => {
  return {
    terms: store.common.terms || null,
    profile: store.profile.profile || {},
  };
};

export default connect(stateToProps)(withRouter(withTranslation(Students)));
